<script>
import { useAdmin } from 'dashboard/composables/useAdmin';
import BackButton from '../../../components/widgets/BackButton.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

import AtendeTotalCreateStandbyTeamDistribution from './teams/atendeTotal/CreateStandbyTeamDistribution.vue';

export default {
  components: {
    BackButton,
    NextButton,
    AtendeTotalCreateStandbyTeamDistribution,
  },
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { isAdmin } = useAdmin();
    return {
      isAdmin,
    };
  },
  data() {
    return {
      showCreateStandbyTeamDistributionPopup: false,
    };
  },
  computed: {
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
    currentPage() {
      return this.$store.state.route.name;
    },
    inTeamStandbiesListPage() {
      return this.currentPage === 'team_standbies_list';
    },
  },
  methods: {
    openCreateStandbyTeamDistributionPopup() {
      this.showCreateStandbyTeamDistributionPopup = true;
    },
    hideCreateStandbyTeamDistributionPopup() {
      this.showCreateStandbyTeamDistributionPopup = false;
    },
  },
};
</script>

<template>
  <div
    class="flex justify-between items-center h-20 min-h-[3.5rem] px-4 py-2 bg-n-background"
  >
    <h1 class="flex items-center mb-0 text-2xl text-n-slate-12">
      <BackButton
        v-if="showBackButton"
        :button-label="backButtonLabel"
        :back-url="backUrl"
        class="ml-2 mr-4"
      />

      <slot />
      <span class="text-xl font-medium text-n-slate-12">
        {{ headerTitle }}
      </span>
    </h1>
    <!-- Zimobi: the team standbies page creates its standby schedule from the header. -->
    <NextButton
      v-if="inTeamStandbiesListPage"
      label="Criar novo plantão"
      icon="i-lucide-circle-plus"
      @click="openCreateStandbyTeamDistributionPopup"
    />
    <woot-modal
      v-if="showCreateStandbyTeamDistributionPopup"
      v-model:show="showCreateStandbyTeamDistributionPopup"
      :on-close="hideCreateStandbyTeamDistributionPopup"
    >
      <AtendeTotalCreateStandbyTeamDistribution
        :on-close="hideCreateStandbyTeamDistributionPopup"
      />
    </woot-modal>
  </div>
</template>
